import request from "@/utils/request";

// =============================支付配置start =======================================================================
/**
 * 新增/修改 虚拟货币
 * @param params
 * @returns {*}
 */
export function createVirtualCurrency(params) {
  return request({
    url: "/api/backend/trade/vc/createVirtualCurrency",
    method: "post",
    data: params
  });
}

/**
 * 查询列表 虚拟货币
 * @param params
 * @returns {*}
 */
export function getVirtualCurrencyList(params) {
  return request({
    url: "/api/backend/trade/vc/getVirtualCurrencyList",
    method: "get",
    params
  });
}

/**
 * 切换 虚拟货币状态
 * @param params
 * @returns {*}
 */
export function updateVirtualCurrency(params) {
  return request({
    url: "/api/backend/trade/vc/updateVirtualCurrency",
    method: "post",
    data: params
  });
}

/**
 * 查询列表 银行转账
 * @param params
 * @returns {*}
 */
export function getBankAccountList(params) {
  return request({
    url: "/api/backend/trade/br/getBankAccountList",
    method: "get",
    params
  });
}

/**
 * 查询地区 银行转账
 * @param params
 * @returns {*}
 */
export function getSupportRegion(params) {
  return request({
    url: "/api/backend/trade/br/getSupportRegion",
    method: "get",
    params
  });
}
/**
 * 新增/修改 银行转账
 * @param params
 * @returns {*}
 */
export function createBankAccount(params) {
  return request({
    url: "/api/backend/trade/br/createBankAccount",
    method: "post",
    data: params
  });
}

/**
 * 切换 银行转账状态
 * @param params
 * @returns {*}
 */
export function updateBankAccount(params) {
  return request({
    url: "/api/backend/trade/br/updateBankAccount",
    method: "post",
    data: params
  });
}

// =============================支付配置 end =======================================================================

/**
 * 查询交易订单
 * @param params
 * @returns {*}
 */
export function getTradeList(params) {
  return request({
    url: "/api/backend/trade/order/getTradeList",
    method: "get",
    params
  });
}
/**
 * 查询交易类别
 * @param params
 * @returns {*}
 */
export function getCategory(params) {
  return request({
    url: "/api/backend/trade/order/getCategory",
    method: "get",
    params
  });
}
/**
 * 确认 交易订单
 * @param params
 * @returns {*}
 */
export function tradeConfirm(params) {
  return request({
    url: "/api/backend/trade/order/tradeConfirm",
    method: "post",
    data: params
  });
}
